import { useEffect, useState } from "react";
import { DashboardResponse } from "../../../model/app/DashboardResponse";
import { ResponsiveContainer } from "recharts";
import { Col, Row } from "react-bootstrap";
import { BsCalendarDate, BsQuestionCircle } from "react-icons/bs";
import Chart from "react-apexcharts";
import { CircularProgress, Tooltip } from "@material-ui/core";
import SummaryAdminSection from "./SummaryAdmin";
import TableSection from "./Table";
import { UserRole } from "../../../constants/enum/UserRole";
import getAdminDashboard from "./getAdminDashboard";
import SummaryTeacherSection from "./SummaryTeacher";
import getTeacherDashboard from "./getTeacherDashboard";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

export function DashboardView() {
  const user = useSelector((store: any) => store.auth.me);
  const dispatch = useDispatch();
  const [from, setFrom] = useState(
    new Date()
      .toLocaleDateString("ja-JP", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      })
      .replaceAll("/", "-")
  );
  const [to, setTo] = useState("");
  let widgets: any = [];
  useEffect(() => {
    // if (
    //   user?.role === UserRole.ADMIN_USER ||
    //   user?.role === UserRole.SUPER_USER
    // ) {
    //   getAdminDashboard({ from, to, dispatch, addWidget, fetchId });
    // }
    // if (
    //   user?.role === UserRole.TEACHER_USER
    // ) {
    //   getTeacherDashboard({ from, to, dispatch, addWidget, fetchId });
    // }
  }, [from, to]);

  const handleDataFilterChange = (event: any) => {
    const value = event.target.value;
    let temp_to = new Date();

    switch (value) {
      case "1":
        temp_to = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
        break;
      case "7":
        temp_to = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case "30":
        temp_to = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000);
        break;
      case "90":
        temp_to = new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000);
        break;
      case "180":
        temp_to = new Date(new Date().getTime() - 180 * 24 * 60 * 60 * 1000);
        break;
      case "365":
        temp_to = new Date(new Date().getTime() - 365 * 24 * 60 * 60 * 1000);
        break;
      default:
        break;
    }

    setTo(
      temp_to
        .toLocaleDateString("ja-JP", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        })
        .replaceAll("/", "-")
    );
  };

  return (
    <div>
      <div
        style={{
          // backgroundColor: "red",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          overflow: "hidden",
          padding: "2rem",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            gap: "1rem",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h2 style={{ fontSize: "1.8rem", fontWeight: "bold" }}>
              {new Date().getHours() >= 5 && new Date().getHours() < 12
                ? "Bom dia"
                : new Date().getHours() >= 12 && new Date().getHours() < 18
                ? "Boa tarde"
                : "Boa noite"}
              , {user?.name}!
            </h2>
            <span
              style={{
                fontSize: "1rem",
                color: "#6c757d",
              }}
            >
              Seja bem-vindo(a) ao painel Dashboard.
            </span>
          </div>

        
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
            marginTop: "2rem",
          }}
        >
          {user?.role === UserRole.ADMIN_USER ||
          user?.role === UserRole.SUPER_USER ? (
            <SummaryAdminSection />
          ) : null}
          {user?.role === UserRole.COLABORATOR_USER ? (
            <SummaryTeacherSection />
          ) : null}
            <p style={{fontSize:20,textAlign:'center',marginBottom:0}}><b>Escolha uma das opções</b></p>

          <div style={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <div>

            <Link to={'/usabilidade/texto'}><button className="btn btn-outline-primary btn-lg w-100">
              Usabilidade
            </button></Link>
            <br/>
            <br/>

            <Link to={'/manutenibilidade/texto'}><button className="btn btn-outline-danger btn-lg w-100">
            Manutenibilidade
            </button></Link>
            <br/>
            <br/>

            <Link to={'/resultados/visualizar'}><button className="btn btn-outline-success btn-lg w-100">
            Resultados (Gerais) 
            </button></Link>
            </div>

          </div>

        
        </div>
      </div>
    </div>
  );
}
